import { createPortal } from "react-dom";
import { usePmsTheme } from "../../Components/PmsThemeContext";
import useItemDialogFocus from "./useItemDialogFocus";
import { itemCatalogText } from "./itemCatalogMessages";
import "../PurchasingUi.css";
import "./ItemCatalog.css";

export function ItemRecipeUsageButton({ item, onOpen }) {
  const { languageId } = usePmsTheme();
  const t = (text) => itemCatalogText(languageId, text);
  const recipes = item.recipe_usage || [];
  if (!recipes.length) return <span className="spx-muted" title={t("Not used in recipes")}>-</span>;
  const label = `${t("View recipes")}: ${item.name} (${recipes.length})`;
  return <button type="button" className="ifm-recipeButton" title={label} aria-label={label}
    aria-haspopup="dialog" onClick={() => onOpen(item.id)}>
    <svg viewBox="0 0 28 28" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" aria-hidden="true">
      <circle cx="14" cy="14" r="8" /><circle cx="14" cy="14" r="5" />
      <path d="M2 3v7c0 2 3 2 3 0V3M3.5 3v22M26 3c-3 3-3 8 0 10V3v22" />
    </svg>
  </button>;
}

export default function ItemRecipeUsage({ item, onClose }) {
  const { themeId, languageId } = usePmsTheme();
  const t = (text) => itemCatalogText(languageId, text);
  const dialogRef = useItemDialogFocus(Boolean(item), false, onClose);
  if (!item) return null;
  return createPortal(<div className="pilcore-purchasing-overlay pu-item-dialog ifm-recipeDialog" data-theme={themeId}
    onClick={(event) => { if (event.target === event.currentTarget) onClose(); }}>
    <section ref={dialogRef} className="spx-modal" role="dialog" aria-modal="true" aria-label={t("Recipes using this item")} tabIndex={-1}>
      <header className="spx-modalHeader">
        <div>
          <div className="spx-modalKicker">{t("Recipes using this item")}</div>
          <h3 className="spx-modalTitle">{item.name}</h3>
          <p className="spx-modalSubtitle">{item.code}</p>
        </div>
        <button type="button" className="spx-closeBtn" aria-label={t("Close recipes popup")} onClick={onClose}>×</button>
      </header>
      <div className="spx-modalBody">
        <ul className="ifm-recipeList">
          {(item.recipe_usage || []).map((recipe) => <li key={recipe.id}>
            <strong>{recipe.name}</strong>{recipe.code && <small>{recipe.code}</small>}
          </li>)}
        </ul>
      </div>
    </section>
  </div>, document.body);
}
